import Quill from 'quill';
const Blockquote = Quill.import('formats/blockquote');
declare const $: any;

export class BlockquoteInlineStyle extends Blockquote {
  static create() {
    BlockquoteInlineStyle.blotName = 'blockquote';
    BlockquoteInlineStyle.tagName = 'blockquote';
    const node = super.create();
    $(node).attr('style', 'border-left: 4px solid #ccc;margin: 0; padding-left: 16px');
    return node;
  }
}
